import { render, staticRenderFns } from "./editget.vue?vue&type=template&id=1e7102f6&scoped=true&"
import script from "./editget.vue?vue&type=script&lang=js&"
export * from "./editget.vue?vue&type=script&lang=js&"
import style0 from "./editget.vue?vue&type=style&index=0&id=1e7102f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7102f6",
  null
  
)

export default component.exports